import { Outlet, useLocation } from "react-router-dom";
import logotr from "../../asset/images/tr.svg";
import { Floaters, Globe } from "asset/icons";
import RiveWrapper from "utilities/RiveWrapper";
import AuthFooter from "component/auth/onboarding/AuthFooter";

const Auth = () => {
    const location = useLocation();

    const isSignInOrSignUp =
        location.pathname.includes("signin") || location.pathname.includes("signup");

    return (
        <>
            {/* Sticky Nav */}
            <nav className="lg:fixed z-30 top-0 left-0 w-full px-6 lg:px-12 py-6">
                <img src={logotr} alt="Tradevu Logo" className="h-8" />
            </nav>

            <div
                className={`relative flex min-h-screen overflow-hidden ${
                    isSignInOrSignUp
                        ? "flex-col-reverse lg:pt-5 lg:flex-row items-center"
                        : "justify-center items-center"
                }`}
            >
                {/* Background animation */}
                <div className="absolute inset-0 z-0 pointer-events-none">
                    <RiveWrapper />
                </div>

                {isSignInOrSignUp && (
                    <div className="w-full lg:w-1/2 flex flex-col items-center justify-between px-6 pt-10 lg:pl-12 z-10">
                        <div className="hidden lg:block relative">
                            <div className="absolute z-20 top-48 left-">
                                <Floaters />
                            </div>
                            <Globe />
                        </div>
                        <AuthFooter />
                    </div>
                )}

                <div
                    className={`flex justify-center relative z-10 ${
                        isSignInOrSignUp
                            ? "w-full max-w-[1000px] lg:w-1/2 px-2 md:mb-10 lg:px-0 lg:order-2"
                            : "w-full max-w-[900px] px-6"
                    }`}
                >
                    <Outlet />
                </div>
            </div>
        </>
    );
};

export default Auth;
